export enum LOCAL_STORAGE_KEY {
    MSAL_ID_TOKEN = 'msal.idtoken',
    TOKEN = 'dma.token',
    CLIENT_MASTER = 'dma.clientMaster',
    SID_CLIENT_MASTER = 'sid.clientMaster',
    EXPIRES_IN = 'dma.expiresIn'
}

export enum AUTHORIZATION_SCHEME {
    BEARER = 'Bearer ',
    BASIC = 'Basic '
}

export enum TAB_NAMES {
    GROSS_MARGIN_SUMMARY = 'Gross Margin Data',
    EMPLOYEE_DATA = 'Employee Data-Actual',
    TARGET_REPORT = 'Employee Data - PIT',
    DRIVE_ENGINEERING_PLAN = 'DRIVE Engineer Plan',
    DRIVE_UPDATE = 'DRIVE Update',
    DRIVE_UPDATE_PLAN = 'DRIVE Update Plan'
}
export enum SID_TAB_NAMES {
    PROJECTS = 'Opportunities',
    REPORTS = 'Sold v/s Staffed',
    RATE_CARD = 'Rate Cards',

}
export enum EXPORT_NAMES {
    GROSS_MARGIN_DATA = 'DMA-Gross Margin Data-Q{quarter-number}-{location}-{value}.xlsx',    
    EMPLOYEE_DATA = 'DMA-Employee Data.xlsx',
    DRIVE_ENGINEERING_PLAN = 'DMA-Drive Engineering Plan.xlsx',
    DRIVE_UPDATE = 'DMA-Drive Update.xlsx',
    DRIVE_PLAN = 'DMA-Drive Update Plan.xlsx',
    OVERALL_STATUS_RPT = 'Action Item Overall Status-{tab}.xlsx',
    ACTION_ITEMS_SAVINGS='Action Item Savings.xlsx',
    EMPLOYEE_DATA_PIT = 'DMA-Employee Data PIT.xlsx',
    SID_RATE_CARD = 'Rate Card Details.xlsx',
    SID_OPPORTUNITY = 'Opportunity Details.xlsx',
    SID_SOLDvsSTAFFED = 'SoldvsStaffed Details.xlsx',
    SID_EDIT_OPPORTUNITY = 'Project Details.xlsx',
    PIT_MARGIN_EMPLOYEE_RPT = 'PIT Margin Employee-{tab}.xlsx',
    CLIENT_PERFORMANCE_RPT = 'Client Performance-{tab}.xlsx',
    ACTION_ITEMS_DELAY = 'Action Item Delay-{tab}.xlsx',
    AOA_EFFECTIVENESS = 'Area to Analyse - Effectiveness.xlsx',
    APPLICATION_USAGE = 'Application Usage.xlsx',
    PIT_MARGIN_PROJECT_RPT = 'PIT Margin Project-{tab}.xlsx',
    APPLICATION_USAGE_SUMMARY = 'Application Usage Summary.xlsx',
    APPLICATION_USER_ACCESS = 'Application User Access.xlsx',
}

export enum EXPORT_TYPES {
    EXCEL = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
}
export enum SFStages {
    L7 = 'L7 - Discovery',
    L6 = 'L6 - Needs Analysis & Qualification',
    L5 = 'L5 - Technical & Requirements Gathering',
    L4 = 'L4 - Working on Proposal/Quote',
    L3 = 'L3 - Customer evaluating',
    L2 = 'L2 - Shortlist / Best of Few',
    L1 = 'L1 - VOC / Negotiating',
    L0 = 'L0 - Pending Sow Sign / Firm Start Date Signaled',
    Won= 'Closed Won',
    Lost= 'Closed Lost'
}
